// supabase-js throws plain objects ({message, details, hint, code}), not Error instances -- the
// once-common `err instanceof Error ? err.message : '<generic fallback>'` pattern silently
// discards the real database error text for every Postgrest/Storage/Auth error and falls through
// to the fallback, which is exactly how "column notes does not exist" became the doubled, useless
// "Failed to create invoice: Failed to create invoice" (Gary, 2026-09-28). Use this everywhere
// a caught error's message needs to reach the user or a log -- checking for a `.message` string
// property covers both real Errors and Supabase's plain error objects.
export function errorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error) return err.message
  if (err && typeof err === 'object' && 'message' in err) {
    const m = (err as { message?: unknown }).message
    if (typeof m === 'string' && m) return m
  }
  return fallback
}
